/* App contexts */

import React from 'react';

export const AuthContext = React.createContext();
export const SocketContext = React.createContext();
